import { Validation, ValueObject } from '@singularsystems/neo-core';

export default class PortalUserPagedCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    public firstName: string = "";

    public lastName: string = "";

    public loginName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Portal User Paged Criteria";
    }
}